module.exports = __webpack_public_path__ + "static/media/f.6d772fce.jpg";